import { render, staticRenderFns } from "./MunicipalContacts.vue?vue&type=template&id=f5d0e1ac&"
import script from "./MunicipalContacts.vue?vue&type=script&lang=js&"
export * from "./MunicipalContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports